import { render, staticRenderFns } from "./OnlineAppointmentsDashboard.vue?vue&type=template&id=b47b6ff8"
import script from "./OnlineAppointmentsDashboard.vue?vue&type=script&lang=js"
export * from "./OnlineAppointmentsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports